module.exports = __webpack_public_path__ + "static/media/fansfirst-logo-mobile-fr.14add05c.svg";